var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessional(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 87.374-85.537 110.136-84.149-108.347c2.646-1.164 5.536-1.789 8.51-1.789z",
    fill: "#b1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.686 89.163-84.15 108.347-85.536-110.136h161.176c2.974 0 5.864.624 8.51 1.789z",
    fill: "#b1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.985 197.51h-170.449l84.15-108.347h.011c2.964 1.302 5.61 3.281 7.727 5.822l73.66 88.214c3.461 4.139 5.091 9.251 4.901 14.311z",
    fill: "#75cef9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 87.378-85.54 110.133h171.08z",
    fill: "#90d8f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.463 197.51h-170.448c-.191-5.06 1.44-10.172 4.901-14.311l73.66-88.214c2.117-2.54 4.763-4.52 7.727-5.822h.011z",
    fill: "#e4f6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.536 197.51-82.466 273.185c-2.032.296-4.107.296-6.139 0l-82.468-273.185z",
    fill: "#75cef9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.93 470.695c-4.583-.667-8.987-2.837-12.405-6.51-.011-.011-.032-.032-.042-.042l-234.837-252.968c-.032-.032-.053-.064-.085-.095-3.525-3.842-5.388-8.68-5.547-13.57h170.448z",
    fill: "#b1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.985 197.51c-.159 4.89-2.022 9.728-5.547 13.57-.032.032-.053.064-.085.095l-234.836 252.968c-.011.011-.032.032-.042.042-3.419 3.673-7.822 5.843-12.405 6.51l82.467-273.185z",
    fill: "#6bbef6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m429.107 307.966 7.507-3.753c3.121-1.56 3.121-6.014 0-7.574l-7.507-3.753c-3.631-1.815-6.469-4.9-7.976-8.668l-6.159-15.397c-1.419-3.549-6.443-3.549-7.862 0l-6.159 15.397c-1.508 3.769-4.346 6.853-7.976 8.668l-7.507 3.753c-3.121 1.56-3.121 6.014 0 7.574l7.507 3.753c3.631 1.815 6.469 4.9 7.976 8.668l6.159 15.397c1.419 3.549 6.443 3.549 7.862 0l6.159-15.397c1.507-3.768 4.345-6.853 7.976-8.668z",
    fill: "#ffe07d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m175.695 396.179 7.507-3.753c3.121-1.56 3.121-6.014 0-7.574l-7.507-3.753c-3.631-1.815-6.469-4.9-7.976-8.668l-6.159-15.397c-1.419-3.549-6.443-3.549-7.862 0l-6.159 15.397c-1.507 3.769-4.346 6.853-7.976 8.668l-7.507 3.753c-3.121 1.56-3.121 6.014 0 7.574l7.507 3.753c3.631 1.815 6.469 4.9 7.976 8.668l6.159 15.397c1.419 3.549 6.443 3.549 7.862 0l6.159-15.397c1.508-3.768 4.346-6.853 7.976-8.668z",
    fill: "#ffe07d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m121.062 97.108 11.885-5.943c3.121-1.56 3.121-6.014 0-7.574l-11.885-5.943c-4.685-2.342-8.347-6.322-10.292-11.185l-9.088-22.72c-1.419-3.549-6.443-3.549-7.862 0l-9.088 22.72c-1.945 4.863-5.607 8.843-10.292 11.185l-11.885 5.943c-3.121 1.56-3.121 6.014 0 7.574l11.885 5.943c4.685 2.342 8.347 6.322 10.292 11.185l9.088 22.72c1.419 3.549 6.443 3.549 7.862 0l9.088-22.72c1.946-4.863 5.608-8.843 10.292-11.185z",
    fill: "#ffe07d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessional);
export default __webpack_public_path__ + "static/media/professional.e7297a9ca609b57bf09f83aba72e0705.svg";
export { ForwardRef as ReactComponent };